import Vue from 'vue'
import VueRouter from 'vue-router'
import preloading from './views/preloading.vue'

Vue.use(VueRouter)

const routes = [{
    path: '', //默认匹配空路由 解决闪烁首页的问题
    name: 'preloading',
    redirect: '/home',
    component: preloading,
  },
  /* 有公共头脚组件路由 */
  {
    path: '/',
    component: () => import('@/pages/page1/views/index'),
    children: [{
        path: 'home',
        name: "Home",
        component: () => import('@/pages/page1/views/home'),
      },
      // about
      {
        path: 'helpWord',
        name: 'helpWord',
        component: () => import('@/pages/page1/views/about/helpWord'),
      },
      {
        path: 'joinUs',
        name: 'joinUs',
        component: () => import('@/pages/page1/views/about/joinUs'),
      },
      {
        path: 'brandHall',
        name: 'brandHall',
        redirect: 'brandHall/brandList',
        component: () => import('@/pages/page1/views/about/brandHall/index'),
        children: [{
            path: 'brandList',
            name: "brandList",
            component: () => import('@/pages/page1/views/about/brandHall/brandList'),
          },
          {
            path: 'brandCategory',
            name: 'brandCategory',
            component: () => import('@/pages/page1/views/about/brandHall/brandCategory'),
          },
        ]
      },
      {
        path: 'wholeBag',
        name: 'wholeBag',
        redirect: 'wholeBag/wholeBagList',
        component: () => import('@/pages/page1/views/about/wholeBag/index'),
        children: [{
            path: 'wholeBagList',
            name: "wholeBagList",
            component: () => import('@/pages/page1/views/about/wholeBag/wholeBagList'),
          },
          {
            path: 'wholeBagDetail',
            name: 'wholeBagDetail',
            component: () => import('@/pages/page1/views/about/wholeBag/newDetail'),
          },
        ]
      },
      {
        path: 'electricBag',
        name: 'electricBag',
        redirect: 'electricBag/electricBagList',
        component: () => import('@/pages/page1/views/about/electricBag/index'),
        children: [{
            path: 'electricBagList',
            name: "electricBagList",
            component: () => import('@/pages/page1/views/about/electricBag/electricBagList'),
          },
          {
            path: 'electricBagDetail',
            name: 'electricBagDetail',
            component: () => import('@/pages/page1/views/about/electricBag/electricBagDetail'),
          },
        ]
      },
      {
        path: 'houseElectrical',
        name: 'houseElectrical',
        component: () => import('@/pages/page1/views/about/houseElectrical'),
      },
      {
        path: 'hotSaleTop',
        name: 'hotSaleTop',
        component: () => import('@/pages/page1/views/about/hotSaleTop'),
      },
      {
        path: 'styleHall',
        name: 'styleHall',
        component: () => import('@/pages/page1/views/about/styleHall'),
      },
      // goods
      {
        path: 'category',
        name: 'category',
        component: () => import('@/pages/page1/views/goods/category'),
      },
      {
        path: 'goodsDetails/:mixSerNo',
        name: 'goodsDetails',
        component: () => import('@/pages/page1/views/goods/goodsDetails'),
      },
      {
        path: 'previewGoods',
        name: 'previewGoods',
        component: () => import('@/pages/page1/views/goods/previewGoods'),
      },
      // 购物车下单
      {
        path: 'shopCart',
        name: 'shopCart',
        component: () => import('@/pages/page1/views/placeOrder/shopCart'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: 'placeOrder',
        name: 'placeOrder',
        component: () => import('@/pages/page1/views/placeOrder/placeOrder'),
        meta: {
          requireAuth: true
        }
      },
      // 支付过程
      {
        path: 'payType',
        name: 'payType',
        component: () => import('@/pages/page1/views/paymentProcess/payType/payType'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: 'platePay',
        name: 'platePay',
        component: () => import('@/pages/page1/views/paymentProcess/payType/platePay'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: 'orderPay',
        name: 'orderPay',
        component: () => import('@/pages/page1/views/paymentProcess/payType/orderPay'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: 'wechatPay',
        name: 'wechatPay',
        component: () => import('@/pages/page1/views/paymentProcess/WechatPay'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: 'payDown',
        name: 'payDown',
        component: () => import('@/pages/page1/views/paymentProcess/payDown'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: 'successPay',
        name: 'successPay',
        component: () => import('@/pages/page1/views/paymentProcess/successPay'),
        meta: {
          requireAuth: true
        }
      },
      //个人中心
      {
        path: 'personalCenter',
        name: 'personalIndex',
        component: () => import('@/pages/page1/views/personalCenter/index'),
        redirect: '/personalCenter/home',
        meta: {
          requireAuth: true
        },
        children: [{
            path: 'home',
            name: 'personHome',
            component: () => import('@/pages/page1/views/personalCenter/home'),
            meta: {
              requireAuth: true
            },
          },
          /* 正在开发页 */
          {
            path: 'developPage',
            name: 'developPage',
            component: () => import('@/pages/page1/views/personalCenter/developPage'),
            meta: {
              requireAuth: true
            },
          },
          {
            path: 'myOrder',
            name: 'myOrder',
            component: () => import('@/pages/page1/views/personalCenter/myOrder'),
            meta: {
              requireAuth: true
            },
          },
          {
            path: 'myOrderDetail',
            name: 'myOrderDetail',
            component: () => import('@/pages/page1/views/personalCenter/myOrder/orderDetail'),
            meta: {
              requireAuth: true
            },
          },
          {
            path: 'cancelDetail',
            name: 'cancelDetail',
            component: () => import('@/pages/page1/views/personalCenter/myOrder/cancelDetail'),
            meta: {
              requireAuth: true
            },
          },
          {
            path: 'followGoods',
            name: 'followGoods',
            component: () => import('@/pages/page1/views/personalCenter/followGoods'),
            meta: {
              requireAuth: true
            },
          },
          {
            path: 'followBrand',
            name: 'followBrand',
            component: () => import('@/pages/page1/views/personalCenter/followBrand'),
            meta: {
              requireAuth: true
            },
          },
          {
            path: 'shipAddress',
            name: 'shipAddress',
            component: () => import('@/pages/page1/views/personalCenter/shipAddress'),
            meta: {
              requireAuth: true
            },
          },
          {
            path: 'userBind',
            name: 'userBind',
            component: () => import('@/pages/page1/views/personalCenter/userBind'),
            meta: {
              requireAuth: true
            },
          },
        ]
      },
      //打印订单
      {
        path: 'printOrder',
        name: 'printOrder',
        component: () => import('@/pages/page1/views/personalCenter/myOrder/printOrder'),
        meta: {
          requireAuth: true
        },
      },
    ]
  },

  // login
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/page1/views/login/login'),
  },
  {
    path: '/wxLogin',
    name: 'wxLogin',
    component: () => import('@/pages/page1/views/login/wxLogin'),
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/pages/page1/views/login/register'),
  },
  {
    path: '/retrievePwd',
    name: 'retrievePwd',
    component: () => import('@/pages/page1/views/login/retrievePwd'),
  },

  // WeChartH5
  {
    path: '/bindH5',
    name: 'bindH5',
    component: () => import('@/pages/page1/views/WeChartH5/bindH5'),
  },
  {
    path: '/bindResult',
    name: 'bindResult',
    component: () => import('@/pages/page1/views/WeChartH5/bindResult'),
  },
  {
    path: '/joinIn',
    name: 'joinIn',
    component: () => import('@/pages/page1/views/WeChartH5/joinIn'),
  },
  {
    path: '/joinResult',
    name: 'joinResult',
    component: () => import('@/pages/page1/views/WeChartH5/joinResult'),
  },

  // 工单H5
  {
    path: '/workLogin',
    name: 'workLogin',
    component: () => import('@/pages/page1/views/workH5/workLogin'),
  },
  {
    path: '/workOrder',
    name: 'workOrder',
    component: () => import('@/pages/page1/views/workH5/workOrder'),
  },
  {
    path: '/workDetail',
    name: 'workDetail',
    component: () => import('@/pages/page1/views/workH5/workDetail'),
  },
  {
    path: '/signGoods',
    name: 'signGoods',
    component: () => import('@/pages/page1/views/workH5/signGoods'),
  },
  {
    path: '/questionType',
    name: 'questionType',
    component: () => import('@/pages/page1/views/workH5/questionType'),
  },
  {
    path: '/rebackGoods',
    name: 'rebackGoods',
    component: () => import('@/pages/page1/views/workH5/rebackGoods'),
  },
  {
    path: '/h5MyOrder',
    name: 'h5MyOrder',
    component: () => import('@/pages/page1/views/workH5/h5MyOrder'),
  },
  {
    path: '/checkOrder',
    name: 'checkOrder',
    component: () => import('@/pages/page1/views/workH5/checkOrder'),
  },
  {
    path: '/checkOrderResult',
    name: 'checkOrderResult',
    component: () => import('@/pages/page1/views/workH5/checkOrderResult'),
  },

  /* h5*/
  // 分享入驻链接
  {
    path: '/invitation/:id',
    name: 'invitation',
    component: () => import('@/pages/page1/views/browserH5/invitation'),
  },
  // 客户填写资料
  {
    path: '/collect/:id',
    name: 'collect',
    component: () => import('@/pages/page1/views/browserH5/collect'),
  },
  // 提交审核中
  {
    path: '/examine',
    name: 'examine',
    component: () => import('@/pages/page1/views/browserH5/examine'),
  },
  // 活动页
  {
    path: '/activity/:id',
    name: 'activity',
    component: () => import('@/pages/page1/views/browserH5/activity'),
  },

  // 404
  {
    path: '*',
    name: 'notfount',
    component: () => import('@/pages/publicView/other/notfount'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  linkActiveClass: 'router-link-active', //为激活的路由添加类名，子路由激活父也有
  // router-link-exact-active //完全匹配当前路由添加的样式
})
//关掉跳转重复路由报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};
export default router